import { useState } from 'react';
import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/home';

export default function NewsSection() {
  const [testimonialIdx, setTestimonialIdx] = useState(0);
  const current = testimonials[testimonialIdx];

  const prev = () => setTestimonialIdx((testimonialIdx - 1 + testimonials.length) % testimonials.length);
  const next = () => setTestimonialIdx((testimonialIdx + 1) % testimonials.length);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 flex items-center gap-2">
              <span className="text-foreground-300">「</span>
              用户口碑
              <span className="text-foreground-300">」</span>
            </h2>

            <div className="bg-background-50 rounded-2xl p-6 md:p-8 relative">
              <div className="inline-flex items-center gap-1 mb-4 px-3 py-1.5 bg-accent-100 rounded-full">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="text-accent-700 text-sm font-semibold">{current.rating}.0</span>
              </div>

              <blockquote className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed mb-6 italic">
                &ldquo;{current.content}&rdquo;
              </blockquote>

              <div className="flex items-center gap-4">
                <img
                  src={current.avatar}
                  alt={current.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-foreground-900 font-semibold text-sm">{current.name}</p>
                  <p className="text-foreground-500 text-xs">{current.role}</p>
                </div>
                <div className="ml-auto flex gap-2">
                  <button
                    onClick={prev}
                    className="w-9 h-9 rounded-lg border border-foreground-200 flex items-center justify-center text-foreground-500 hover:bg-background-100 hover:border-foreground-300 transition-colors cursor-pointer"
                    aria-label="上一条"
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>
                  <button
                    onClick={next}
                    className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center text-white hover:bg-foreground-800 transition-colors cursor-pointer"
                    aria-label="下一条"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-8">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                最新资讯
              </h2>
              <Link
                to="/article"
                className="whitespace-nowrap text-sm text-accent-600 hover:text-accent-700 font-medium flex items-center gap-1 transition-colors cursor-pointer"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="space-y-4">
              <Link
                to="/article/xiazai-jiaocheng-2026"
                className="flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors group cursor-pointer"
              >
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20showing%20video%20app%20interface%2C%20minimalist%20tech%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20soft%20shadows%2C%20neutral%20background&width=200&height=200&seq=article-thumb-01&orientation=squarish"
                    alt="91在线视频APP下载安装完整教程"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-accent-600 font-medium">使用教程</span>
                    <span className="text-xs text-foreground-400">2026-07-06</span>
                  </div>
                  <h4 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
                    91在线视频APP下载安装完整教程（2026最新版）
                  </h4>
                  <p className="text-xs text-foreground-500 line-clamp-1 hidden sm:block">
                    本文详细介绍91在线视频APP在iOS和Android设备上的下载安装步骤，以及常见问题排查方法。
                  </p>
                </div>
              </Link>

              <Link
                to="/article/vip-gongneng-jieshao"
                className="flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors group cursor-pointer"
              >
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Premium%20membership%20concept%20with%20elegant%20gold%20accents%2C%20luxury%20lifestyle%20aesthetic%2C%20dark%20background%20with%20warm%20highlights%2C%20sophisticated%20visual%2C%20clean%20composition&width=200&height=200&seq=article-thumb-02&orientation=squarish"
                    alt="91在线视频VIP会员权益全面解析"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-accent-600 font-medium">功能更新</span>
                    <span className="text-xs text-foreground-400">2026-07-04</span>
                  </div>
                  <h4 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
                    91在线视频VIP会员权益全面解析
                  </h4>
                  <p className="text-xs text-foreground-500 line-clamp-1 hidden sm:block">
                    详细了解VIP会员专属权益：无广告观看、超清画质、离线缓存、专属客服等内容。
                  </p>
                </div>
              </Link>

              <Link
                to="/article/xinpian-shangxian-7yue"
                className="flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors group cursor-pointer"
              >
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Film%20reel%20and%20cinema%20concept%2C%20artistic%20movie%20themed%20still%20life%2C%20warm%20vintage%20tones%2C%20creative%20composition%2C%20soft%20dramatic%20lighting%2C%20cinematography%20aesthetic&width=200&height=200&seq=article-thumb-03&orientation=squarish"
                    alt="2026年7月最新上线影片清单"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-accent-600 font-medium">内容推荐</span>
                    <span className="text-xs text-foreground-400">2026-07-03</span>
                  </div>
                  <h4 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
                    2026年7月最新上线影片清单
                  </h4>
                  <p className="text-xs text-foreground-500 line-clamp-1 hidden sm:block">
                    本月多部热门大片和电视剧陆续上线，包括多部豆瓣高分作品。
                  </p>
                </div>
              </Link>

              <Link
                to="/article/anquan-fangwen-zhinan"
                className="flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors group cursor-pointer"
              >
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20clean%20modern%20design%2C%20professional%20tech%20aesthetic%2C%20blue%20holographic%20elements%20on%20dark%20background%2C%20minimalist%20style&width=200&height=200&seq=article-thumb-04&orientation=squarish"
                    alt="91在线视频安全访问指南"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-accent-600 font-medium">安全公告</span>
                    <span className="text-xs text-foreground-400">2026-07-01</span>
                  </div>
                  <h4 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
                    91在线视频安全访问指南
                  </h4>
                  <p className="text-xs text-foreground-500 line-clamp-1 hidden sm:block">
                    为了保障您的账号和隐私安全，请务必通过官方渠道访问91在线视频。
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}